import { render, staticRenderFns } from "./TableUserGroupProjects.vue?vue&type=template&id=2b8708c7&"
import script from "./TableUserGroupProjects.vue?vue&type=script&lang=js&"
export * from "./TableUserGroupProjects.vue?vue&type=script&lang=js&"
import style0 from "./TableUserGroupProjects.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports